export default __webpack_public_path__ + "static/media/pr_2024.ae3fea92.webm";